<template>
  <div class="fixed-tab">
    <div class="float-tabs">
      <div class="float-header">
        <img src="../../../assets/images/apply/float-tab.svg" alt="">
        <span>申请表目录</span>
      </div>
      <div class="float-tab-list">
        <div class="float-tab-item" v-for="(item, index) in menus" :key="index" @click="goAnchor(item.itemCode, 1)" :class="{'is-active': item.itemCode === activeTab}">
          <span>{{item.itemName}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ApplyMenus",
  props: {
    menus: {
      type: Array,
      default() {
        return []
      }
    },
    top: {
      type: Number,
      default: 278
    }
  },
  data() {
    return {
      activeTab: 'ApplyInfo',
    }
  },
  mounted() {
    document.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.menus.forEach(v => {
        const tabEl = document.querySelector('#' + v.itemCode);
        if (!tabEl) return
        const rect = tabEl.getBoundingClientRect().top
        if (rect <= this.top) {
          this.activeTab = v.itemCode
        }
      })
    },
    goAnchor(selector, time) {
      this.activeTab = selector
      const second = time || 500
      // 最好加个定时器给页面缓冲时间
      setTimeout(() => {
        // 获取锚点元素
        let anchor = document.querySelector('#' + selector)
        if (anchor) {
          anchor.scrollIntoView()
        }
      }, second)
    },
  }
};
</script>

<style scoped lang="scss">
.fixed-tab {
  position: fixed;
  width: 1226px;
  background: black;
  left: 0;
  right: 0;
  margin: auto;
}
.float-tabs {
  position: absolute;
  width: 180px;
  left: -200px;
  top: 0;
  .float-header {
    height: 40px;
    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
    background: rgb(255, 255, 255);
    color: rgb(51, 51, 51);
    font-size: 14px;
    display: flex;
    align-items: center;
    padding-left: 11px;
    img {
      width: 15px;
      margin-right: 8px;
    }
  }
  .float-tab-list {
    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
    background: rgb(248, 248, 248);
    font-size: 14px;
    line-height: 40px;
    color: #878787;
    padding: 8px 0 11px 43px;
    position: relative;
    &:before {
      content: "";
      position: absolute;
      width: 2px;
      height: calc(100% - 57px);
      top: 26px;
      left: 25.5px;
      background: rgb(227, 226, 226);
    }
    .float-tab-item {
      position: relative;
      span {
        cursor: pointer;
      }
      &:before {
        content: "";
        position: absolute;
        width: 7px;
        height: 7px;
        background: rgb(153, 153, 153);
        top: 17px;
        left: -20px;
        border-radius: 50%;
      }
      &.is-active {
        color: #CA4300;
        &:before {
          background: #CA4300;
        }
      }
    }
  }
}
</style>
